import ApiService from './ApiService'

const api = ApiService

export const officeSettings = ({ slug }) => {
  return api.get(`/portal/office/${slug}`)
}
